import Address from './Components/Address'
import PartialAddress from './Components/CountryState'

export default function (formulateInstance) {
	formulateInstance.extend({
		components: {
			Address,
			PartialAddress
		},
		library: {
			full_address: {
				classification: 'full-address',
				component: 'Address'
			},
			partial_address: {
				classification: 'partial-address',
				component: 'PartialAddress'
			}
		}
	})
}
